import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CORGI_ALLOW_IFRAME_EMBEDDING = createFcmDetails('corgi_allow_iframe_embedding', {
	owner: 'Site Platform',
	context: 'iframe policies for Corgi apps',
	description: `
	This can be used to allow specific domains to iframe embed specific Corgi pages.

	The key is the page's route id. The route id can be retrieved from https://www.staging-change.org/corgi/stats/routes.html
	`,
	template: {
		topic: {
			allowedAncestorDomains: ['www.change.vote'],
		},
	},
	import: false,
});
